// src/components/dashboard/employee/MissedTrainingsWidget.js
import React from 'react';
import { Table } from 'react-bootstrap';
import DashboardCard from '../DashboardCard';

function MissedTrainingsWidget({ trainings, loading }) {
  return (
    <DashboardCard
      title="Missed Trainings"
      icon="bi-exclamation-triangle"
      loading={loading}
      isEmpty={!loading && trainings.length === 0}
      emptyMessage="No missed trainings."
    >
      <Table borderless size="sm" className="mb-0 align-middle">
        <tbody>
          {trainings.map(t => (
            <tr key={t.id}>
              <td>
                <div className="fw-semibold">{t.title}</div>
                <div className="text-muted small">{t.code} &middot; {t.end_date}</div>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </DashboardCard>
  );
}

export default MissedTrainingsWidget;
